<template lang="html">
  <div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <h3 class="panel-title">{{ team.name }}</h3>
      </div>
      <div class="panel-body">
        <h3>{{ team.name }}</h3>
        <h3 v-for="award in team.awards">{{ award.name}}</h3>
        <table v-if="team.registrations" class="table table-condensed table-bordered table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>País</th>
              <th>Quitar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="registration in team.registrations | filterBy filterKey | orderBy 'player.surname'">
              <td>
                {{registration.player.surname}} {{registration.player.mothers_surname}} {{ registration.player.name}} {{registration.player.middle_name}}
              </td>
              <td>
                <span class="flag-icon flag-icon-{{registration.player.country.code | lowercase}}"></span>
              </td>
              <td>
                <button type="button" class="btn btn-default" @click="removeFromTeam(registration)">-</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Team from '../../api/team'
import Player from '../../api/player'
import {
  getConfigChampionship,
  getConfigTeam,
} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
export default {
  vuex: {
    getters: {
      team: getConfigTeam,
    },
    actions
  },
  data() {
    return {
    }
  },
  computed: {},
  ready() {},
  attached() {},
  methods: {
    removeFromTeam(registration) {
      let ApiPlayer = new Player()
      ApiPlayer.detach(registration.id, this.team.id).then(response => {
        this.getTeam(this.team.id)
      })
    },
    getTeam(id) {
      let ApiTeam = new Team()
      this.fetchConfigAwards()
      ApiTeam.get(id).then(response => {
        this.setConfigTeam(response.data)
      }, error => {
        this.setError({show: true, message:'Failed getting team'})
      })
    }
  },
  components: {}
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** TeamSelected.vue?4c48bb1c
 **/